import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useStore } from "../context/StoreContext";
import { useAuth } from "../context/AuthContext";
import { GateWall } from "./gate/GateWall";

export const SiteGate = ({ children }) => {
  const { config, lang, setLang } = useStore();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem("nura_preview") === "1");
  const [viewAsVisitor, setViewAsVisitor] = useState(() => sessionStorage.getItem("nura_view_visitor") === "1");
  const mode = config.site_mode || "live";
  const isAdmin = user?.role === "admin";

  if (mode === "live" || mode === "launch" || pathname.startsWith("/admin")) return children;

  if (unlocked || (isAdmin && !viewAsVisitor)) {
    return (
      <>
        {isAdmin && (
          <div className="fixed top-0 inset-x-0 z-[70] bg-amber-400 text-stone-900 text-[11px] font-mono uppercase tracking-[0.15em] px-4 py-1.5 flex flex-wrap items-center justify-center gap-3" data-testid="admin-mode-ribbon">
            <span>Site en mode {mode === "maintenance" ? "maintenance" : "coming soon"} — visible par vous (admin) uniquement</span>
            <button data-testid="admin-view-as-visitor" onClick={() => { sessionStorage.setItem("nura_view_visitor", "1"); sessionStorage.removeItem("nura_preview"); setUnlocked(false); setViewAsVisitor(true); }} className="underline">Voir comme un visiteur</button>
          </div>
        )}
        {children}
      </>
    );
  }

  return (
    <GateWall
      mode={mode} config={config} lang={lang} setLang={setLang} isAdmin={isAdmin}
      onUnlock={() => { sessionStorage.setItem("nura_preview", "1"); setUnlocked(true); }}
      onBackToAdmin={() => { sessionStorage.removeItem("nura_view_visitor"); setViewAsVisitor(false); }}
    />
  );
};
